import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _LinkGetter = Getter.of();
export const _LinkResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _LinkResponse2Link = _Response2ResponseData();
export const _Link2Data = Fold.compose(_LinkGetter, Res._Response());
export const _Link2Attributes = Fold.compose(_Link2Data, Lens.prop("attributes"));
export const _LinkAttributes2Alias = Fold.compose(_Link2Attributes, Lens.prop("alias"));
export const _LinkAttributes2Description = Fold.compose(_Link2Attributes, Lens.prop("description"));
export const _LinkAttributes2Hints = Fold.compose(_Link2Attributes, Lens.prop("hints"));
export const _LinkAttributes2Href = Fold.compose(_Link2Attributes, Lens.prop("href"));
export const _LinkAttributes2Kind = Fold.compose(_Link2Attributes, Lens.prop("kind"));
export const _LinkAttributes2Name = Fold.compose(_Link2Attributes, Lens.prop("name"));
export const _LinkAttributes2Packages = Fold.compose(_Link2Attributes, Lens.prop("packages"));
export const _LinkAttributes2Published = Fold.compose(_Link2Attributes, Lens.prop("published"));
export const _LinkAttributes2State = Fold.compose(_Link2Attributes, Lens.prop("state"));
export const _LinkAttributes2Title = Fold.compose(_Link2Attributes, Lens.prop("title"));
export const _Link2Images = Fold.compose(_LinkGetter, Res._Rel("images"), Res._ForEach());
export const _Link2LinkedContentRoutes = Fold.compose(_LinkGetter, Res._Rel("linkedContentRoutes"), Res._ForEach());
export const _Link2LinkedContentCollection = Fold.compose(_LinkGetter, Res._RelAssoc("linkedContent", "collection"));
export const _Link2LinkedContentImage = Fold.compose(_LinkGetter, Res._RelAssoc("linkedContent", "image"));
export const _Link2LinkedContentArticle = Fold.compose(_LinkGetter, Res._RelAssoc("linkedContent", "article"));
export const _Link2LinkedContentShows = Fold.compose(_LinkGetter, Res._RelAssoc("linkedContent", "shows"));
export const _Link2LinkedContentChannel = Fold.compose(_LinkGetter, Res._RelAssoc("linkedContent", "channel"));
export const _Link2LinkedContentVideo = Fold.compose(_LinkGetter, Res._RelAssoc("linkedContent", "video"));

